import { Route, BrowserRouter as Router, Routes, Navigate } from "react-router-dom";
import { ZerezesClubAccountProvider } from "./providers/ZerezesClubAccountProvider";
import ZClubAccountPage from "./pages/ZClubAccount/ZClubAccountPage";

export const routes = {
  HomePage: '/',
  CustomerRecipeHistoricPage: '/customer-recipe-historic',
  AddCustomerRecipePage: '/add-customer-recipe',
  EditCustomerRecipePage: '/edit-customer-recipe',
  AddOrderRecipePage: '/add-order-recipe',
  EditOrderRecipePage: '/add-order-recipe',
  ZClubAccountPage: '/zclub-account'
};

const AppRoutes = () => {
  return (
    <Router>
      <ZerezesClubAccountProvider>
        <Routes>
          <Route path={routes.HomePage} element={<ZClubAccountPage />} />
          <Route path={routes.ZClubAccountPage} element={<ZClubAccountPage />} />
          <Route path="*" element={<Navigate to={routes.HomePage} />} />
        </Routes>
      </ZerezesClubAccountProvider>
    </Router>
  )
};

export default AppRoutes;